import { Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Login from "./pages/login/Login";
import CustomerDetails from "./pages/customerDetails/CustomerDetails";
import Cart from "./pages/cart/Cart";
import Payment from "./pages/payment/Payment";
import Profile from "./pages/profile/Profile";
import ProtectedRoute from "./components/hoc/protected";
import Success from "./pages/success/success";
import List from "./components/productList/List";
import Report from "./pages/report/Report";
import Customer from "./pages/customer/Customer"
import PurchaseQuestion from "./pages/PurchaseQuestion/PurchaseQuestion"
import DashboardLayout from "./components/dashboardLayout";

import "./custom.scss";
import Dashboard from "./components/dashboard/Dashboard";
import OldPurchaseEstimate from "./components/oldgold/oldGold";
import OldGoldList from "./pages/oldGoldList";
import CategoryList from "./pages/categoryList";
import SalesOrderAdvanced from './pages/SalesOrderAdvanced/index'
function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Login />} />
        <Route path="categories" element={<ProtectedRoute><CustomerDetails /></ProtectedRoute>} />
        <Route path="categories/:label" element={<ProtectedRoute><List /></ProtectedRoute>} />
        <Route path="checkout/cart" element={<ProtectedRoute requireUser={true}><Cart /></ProtectedRoute>} />
        <Route path="checkout/payment" element={<ProtectedRoute requireUser={true}><Payment /></ProtectedRoute>} />
        <Route path="success" element={<ProtectedRoute requireUser={true}><Success /></ProtectedRoute>} />
        <Route path="profile" element={<ProtectedRoute requireUser={true}><Profile /></ProtectedRoute>} />
        {/* <Route path="reports" element={<ProtectedRoute restrictedForUsers={true}><Report /></ProtectedRoute>}/> */}
        <Route path='session/purchased' element={<PurchaseQuestion />} />
        <Route path="session/customer" element={<Customer />} />
        <Route path="oldgold" element={<OldPurchaseEstimate />} />
        <Route path="oldgold/list" element={<OldGoldList />} />
        <Route path="salesorderadvanced" element={<SalesOrderAdvanced />} />
      </Route>
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="reports" element={<Report />} />
        <Route path="category/list" element={<CategoryList />} />
      </Route>

    </Routes>

  );
}

export default App;
